export const CLOSE_SPECIAL_SSR_MODAL = 'CLOSE_SPECIAL_SSR_MODAL'

export default () => ({
  type: CLOSE_SPECIAL_SSR_MODAL,
})
